<template>
    <vx-expandable-card>
        <template v-slot:header> Source Team </template>
        <template v-slot:content>
            <vx-selectable
                v-model="model.source_team"
                :options="teams"
                @search="searchTeams"
                :error="displayFirstError(validate.source_team)"
                label="name"
                size="lg"
                :clearable="true"
            ></vx-selectable>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxSelectable } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { computed, onUnmounted } from 'vue';
import { useSearchRequest } from '~/composables/useSearchRequest';
import { adminCloningClient } from '~/services';
import { displayFirstError } from '~/utils/validation';

const model = defineModel('form', {
    type: Object,
    required: true,
});

const validate = useVuelidate(
    {
        source_team: {
            required,
        },
    },
    model
);

const { response, createSearch, cancelSearch, cancelKey } = useSearchRequest(adminCloningClient, 'clone-teams', 350);
const teams = computed(() => response.value ?? []);
const searchTeams = createSearch(async (search) => {
    const { data } = await adminCloningClient.getTeams(
        {
            query: search,
            sort_field: 'id',
            sort_dir: 'desc',
            per_page: 100,
        },
        { cancelKey }
    );

    return data.data.map((team) => ({
        ...team,
        name: `${team.id} - ${team.name}`,
    }));
});

searchTeams('');

onUnmounted(() => cancelSearch());
</script>
